<section class="results-type">
  <header class="results-type__header p">
    <div class="results-type__title">
      <h5>{{ type.title }}</h5>
      <div class="results-type__summary">
        <strong class="text-primary" translate [translateParams]="{ count: type.items.length }"> general.search.results </strong>
        <span class="d--none--md">{{ "general.search.found" | translate }}</span>
      </div>
    </div>
    <div class="results-type__action">
      <button class="button button--tertiary" *ngIf="type.items.length > 3" (click)="toggle($event)">
        <span *ngIf="!expanded" class="icon icon-ui-plus d--none--sm"></span>
        <span *ngIf="!expanded">{{ "general.search.show_more" | translate }}</span>
        <span *ngIf="expanded" class="icon icon-ui-minus d--none--sm"></span>
        <span *ngIf="expanded">{{ "general.search.show_less" | translate }}</span>
      </button>
    </div>
  </header>
  <ul class="results-type__items" *ngIf="type.mode === 'list'">
    <li *ngFor="let item of type.items | slice: 0 : limit">
      <air-search-results-item [item]="item.page" [userEventSource]="userEventSource"></air-search-results-item>
    </li>
  </ul>
  <ul class="product-list" *ngIf="type.mode === 'product'">
    <li class="product-list__item" *ngFor="let item of type.items | slice: 0 : limit">
      <air-product-card
        [product]="item.product"
        [isDescriptionHidden]="true"
        [userEventSource]="userEventSource"
        [userEventObject]="item.userEventObject"
      ></air-product-card>
    </li>
  </ul>
  <ul class="product-list product-list--sm" *ngIf="type.mode === 'physical-product'">
    <li class="product-list__item" *ngFor="let item of type.items | slice: 0 : limit">
      <air-product-card
        [product]="item.product"
        [isDescriptionHidden]="true"
        [userEventSource]="userEventSource"
        [userEventObject]="item.userEventObject"
      ></air-product-card>
    </li>
  </ul>
</section>
